"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from "react";
import { useIntersection } from "react-use";
export default function InfiniteScrollTrigger(t0) {
  const $ = _c(7);
  const {
    onIntersection
  } = t0;
  const elementRef = useRef(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      root: null,
      rootMargin: "0px",
      threshold: 1
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const intersection = useIntersection(elementRef as React.RefObject<HTMLElement>, t1);
  let t2;
  if ($[1] !== intersection?.isIntersecting || $[2] !== onIntersection) {
    t2 = () => onIntersection(intersection?.isIntersecting ?? false);
    $[1] = intersection?.isIntersecting;
    $[2] = onIntersection;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== intersection) {
    t3 = [intersection];
    $[4] = intersection;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  useEffect(t2, t3);
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div ref={elementRef} />;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}